// расскрывающиеся списки

function dropdown() {
  const dropdowns = document.querySelectorAll('.dropdown');
  const selectAll = document.querySelectorAll('.dropdown__select');
  const menuAll = document.querySelectorAll('.dropdown__menu');
  const caretAll = document.querySelectorAll('.dropdown__caret');
  const selectedAll = document.querySelectorAll('.dropdown__selected');
  const clickedAll = document.querySelectorAll('.dropdown__clicked');

  dropdowns.forEach(dropdown => {
    const select = dropdown.querySelector('.dropdown__select');
    const menu = dropdown.querySelector('.dropdown__menu');
    const options = dropdown.querySelectorAll('.dropdown__menu li');
    const selected = dropdown.querySelector('.dropdown__selected');

    const menuHeight = menu.clientHeight + 'px';
    setTimeout(() => {
      menu.style.height = '0px';
    })

    console.log(menuHeight);

    select.addEventListener('click', () => {

      select.classList.toggle('select-clicked');
      menu.classList.toggle('menu-open');
      if (menu.classList.contains('menu-open')) {
        console.log(1)
        menu.style.height = menuHeight;
      } else  {
        console.log(2)
        menu.style.height = '0px';
      }
    });


    options.forEach(option => {
      option.addEventListener('click', () => {
        selected.value = option.value;
        selected.value = option.innerText;
        selected.setAttribute('data-number', option.value)
        select.classList.remove('select-clicked');
        menu.classList.remove('menu-open');
        menu.style.height = '0px';
        select.classList.add('select-clicked');
        selected.classList.add('active');
        options.forEach(option => {
          option.classList.remove('active');
        });
        option.classList.add('active');
      });


    });

  });


  // function dropdownClose(open, content, icon, select) {
  //   for (let i = 0; i < open.length; i++) {
  //     open[i].addEventListener("click", function () {
  //       content[i].classList.toggle("menu-open");
  //
  //       for (let j = 0; j < open.length; j++) {
  //         if (i !== j) {
  //           content[j].classList.remove("menu-open");
  //
  //         }
  //       }
  //     });
  //   }
  // }
  //
  // dropdownClose(selectAll, menuAll, caretAll, selectAll);


}

export {
  dropdown
}
